import { gql } from '@apollo/client';

export const RELEASE_SURVEY_MUTATION = gql`
  mutation ReleaseSurvey($id: Int!) {
    p {
      releaseSurvey(id: $id) {
        success
        message {
          code
          message
        }
        content {
          id
          status
        }
      }
    }
  }
`;
